(function() {
  var AUTOCLICK_INIT_FLAG = '__cardVariantAutoclickInitialized';
  var recentlyHandled = new WeakMap();

  function onReady(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
      return;
    }
    cb();
  }

  function getVariantDataForRoot(variantRoot, cardScope) {
    var card = cardScope || variantRoot.closest('.product-card-wrapper, .card-wrapper');
    var scriptEl = null;
    if (card) scriptEl = card.querySelector('script[id^="Variants-"]');
    if (!scriptEl) {
      var scope = variantRoot.closest('.card__variants') || variantRoot.parentElement;
      if (scope && (!card || card.contains(scope))) {
        scriptEl = scope.querySelector('script[id^="Variants-"]');
      }
    }
    if (!scriptEl) {
      var sheet = document.querySelector('.card-variants-sheet');
      if (sheet && sheet.contains(variantRoot)) scriptEl = sheet.querySelector('script[id^="Variants-"]');
    }
    if (!scriptEl) return [];
    try {
      return JSON.parse(scriptEl.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function getSelectedValues(variantRoot, directInput) {
    var values = [];
    var fieldsets = Array.prototype.slice.call(variantRoot.querySelectorAll('fieldset'));
    var prioritized = [];
    if (directInput) {
      var focusedFieldset = directInput.closest('fieldset');
      if (focusedFieldset) prioritized.push(focusedFieldset);
    }
    fieldsets.forEach(function(fs) {
      if (prioritized.indexOf(fs) === -1) prioritized.push(fs);
    });
    prioritized.forEach(function(fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) values.push(checked.value);
    });
    return values;
  }

  function findMatchingVariant(variants, values) {
    if (!Array.isArray(variants)) return null;
    var strictMatch = variants.find(function(v) {
      return Array.isArray(v.options) &&
        v.options.length === values.length &&
        v.options.every(function(opt, i) { return opt === values[i]; });
    });
    if (strictMatch) return strictMatch;
    return variants.find(function(v) {
      return (values[0] == null || v.option1 === values[0]) &&
        (values[1] == null || v.option2 === values[1]) &&
        (values[2] == null || v.option3 === values[2]);
    }) || null;
  }

  function getVariantRootFromTarget(target) {
    var input = target && target.closest && target.closest('input[type="radio"]');
    if (!input) return { variantRoot: null, directInput: null };
    return {
      variantRoot: input.closest('variant-selects'),
      directInput: input
    };
  }

  function isDuplicateSelection(variantRoot, values) {
    var key = JSON.stringify(values);
    var now = Date.now();
    var prev = recentlyHandled.get(variantRoot);
    if (prev && prev.key === key && (now - prev.time) < 500) return true;
    recentlyHandled.set(variantRoot, { key: key, time: now });
    return false;
  }

  function updateHiddenIdAndSubmit(variantRoot, directInput) {
    var cardWrapper = variantRoot.closest('.product-card-wrapper, .card-wrapper');
    if (!cardWrapper) return;

    var values = getSelectedValues(variantRoot, directInput);
    if (!values.length) return;
    if (isDuplicateSelection(variantRoot, values)) return;

    var variants = getVariantDataForRoot(variantRoot, cardWrapper);
    var match = findMatchingVariant(variants, values);

    var sheet = document.querySelector('.card-variants-sheet');
    var activeCard = sheet ? sheet.__activeCard : null;
    var scopeCard = activeCard && activeCard.contains(variantRoot) ? activeCard : cardWrapper;
    var form = scopeCard.querySelector('form[id^="card-form-"]');
    if (!form) return;

    var idInputs = form.querySelectorAll('input.product-variant-id[name="id"]');
    if (match) {
      idInputs.forEach(function(inp) {
        inp.value = String(match.id);
        inp.removeAttribute('disabled');
      });
    }

    var submitBtn = form.querySelector('[type="submit"], .product-form__submit');
    if (submitBtn) {
      if (match && match.available) submitBtn.removeAttribute('disabled');
      else submitBtn.setAttribute('disabled', 'disabled');
    }

    var inCartUpsell = variantRoot.closest('.cart-drawer-upsell');
    if (inCartUpsell) {
      var infoContainer = variantRoot.closest('.card-variants-info-container');
      if (!infoContainer || !infoContainer.classList.contains('is-open')) return;
    }

    if (match && match.available) {
      if (form.dataset.autoSubmitting === '1') return;
      form.dataset.autoSubmitting = '1';
      setTimeout(function() {
        delete form.dataset.autoSubmitting;
      }, 800);
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else if (submitBtn) submitBtn.click();
    }
  }

  function bindDelegated() {
    if (window[AUTOCLICK_INIT_FLAG]) return;
    window[AUTOCLICK_INIT_FLAG] = true;

    document.addEventListener('change', function(e) {
      var result = getVariantRootFromTarget(e.target);
      if (!result.variantRoot) return;
      setTimeout(function() {
        updateHiddenIdAndSubmit(result.variantRoot, result.directInput);
      }, 0);
    });
  }

  onReady(function() {
    bindDelegated();
  });
})();


